import Network from './network';

export const SideBarApi = async () => {
  const response = await Network.get({
    url: `${import.meta.env.VITE_API_BASE_URL}splashy/v2/dashboards/`,
  });
  return response?.data;
};
